import {useMutation} from "@tanstack/react-query";

import {addClientContactMutationOptions} from "./add-client-contact.mutation-options";

export function useAddClientContact(clientId: string) {
  return useMutation(addClientContactMutationOptions(clientId));
}
